import { useGetMeQuery } from 'store/services/user/meApi';

export const useUserRoles = (skip: boolean = false) => {
  const { data: user } = useGetMeQuery(undefined, { skip });

  // SECURITY: Using backend RBAC system
  // Backend validates roles on every API call
  // This is for UI display only - actual security is enforced server-side

  const isAdmin = user?.roles?.includes('admin') || false;
  const isWriter = user?.roles?.includes('writer') || false;

  // hasAdminAccess: can see the Admin sidebar link and access admin area
  // True for full admins and writers
  const hasAdminAccess = isAdmin || isWriter;

  return { isAdmin, isWriter, hasAdminAccess, user };
};
